/* ============================================
   OTA Product Comparison Table
   File: assets/product-compare.js
   ============================================ */

(function () {
  document.querySelectorAll('.ota-compare').forEach(function (section) {
    var specsUrl = section.dataset.specsUrl;
    if (!specsUrl) return;

    fetch(specsUrl)
      .then(function (res) { return res.json(); })
      .then(function (data) { init(section, data); })
      .catch(function (err) { console.error('[OTA Compare] Failed to load specs:', err); });
  });

  function init(section, data) {
    var products  = data.products;
    var specRows  = data.spec_rows;

    var displayMode = section.dataset.displayMode || 'compare-two-picker-default';
    var preSelectA  = section.dataset.preSelectA  || products[0].id;
    var preSelectB  = section.dataset.preSelectB  || products[1].id;

    var tabPicker   = section.querySelector('.ota-compare__tab--picker');
    var tabAll      = section.querySelector('.ota-compare__tab--all');
    var panelPicker = section.querySelector('.ota-compare__panel--picker');
    var panelAll    = section.querySelector('.ota-compare__panel--all');
    var pickerGrid  = section.querySelector('.ota-compare__picker-grid');
    var allGrid     = section.querySelector('.ota-compare__all-grid');
    var selA        = section.querySelector('.ota-compare__select--a');
    var selB        = section.querySelector('.ota-compare__select--b');

    /* ── Helpers ── */

    function sizePills(sizesStr) {
      return sizesStr.split(',').map(function (s) {
        return '<span class="ota-compare__size-pill">' + s.trim() + '</span>';
      }).join('');
    }

    function specVal(val) {
      var content = (!val || val === '\u2014')
        ? '<span class="ota-compare__dash">\u2014</span>'
        : val;
      return '<div class="ota-compare__spec-val">' + content + '</div>';
    }

    function groupedRows() {
      var groups = [];
      var current = null;
      specRows.forEach(function (row) {
        if (!current || current.category !== row.category) {
          current = { category: row.category, rows: [] };
          groups.push(current);
        }
        current.rows.push(row);
      });
      return groups;
    }

    /* ── Populate selects ── */

    function buildOptions(select) {
      select.innerHTML = '';
      products.forEach(function (p) {
        var opt = document.createElement('option');
        opt.value = p.id;
        opt.textContent = p.name;
        select.appendChild(opt);
      });
    }

    if (selA && selB) {
      buildOptions(selA);
      buildOptions(selB);
      selA.value = preSelectA;
      selB.value = preSelectB;
    }

    /* ── Build product column header ── */

    function colHead(p, colIndex) {
      var imgHtml = p.image_url
        ? '<img class="ota-compare__prod-img" src="' + p.image_url + '" alt="' + p.name + '">'
        : '<div class="ota-compare__prod-img-placeholder">No image</div>';

      return '<a href="' + p.url + '" class="ota-compare__col-head" data-ga-cta="compare_table" data-ga-label="' + p.name + '" data-col="' + colIndex + '" aria-label="View ' + p.name + '">' +
        imgHtml +
        '<p class="ota-compare__prod-name">' + p.name + '</p>' +
        '<p class="ota-compare__prod-tagline">' + p.tagline + '</p>' +
        '<div class="ota-compare__sizes">' + sizePills(p.sizes) + '</div>' +
        '<span class="ota-compare__prod-link">View product</span>' +
        '</a>';
    }

    /* ── Build full grid HTML ── */

    function buildGrid(selectedProducts, gridClass) {
      var html = '<div class="ota-compare__grid ' + gridClass + '">';

      selectedProducts.forEach(function (p, i) {
        html += colHead(p, i);
      });

      groupedRows().forEach(function (group) {
        html += '<div class="ota-compare__category">' + group.category + '</div>';

        group.rows.forEach(function (spec) {
          html += '<div class="ota-compare__spec-label">' + spec.label + '</div>';

          selectedProducts.forEach(function (p) {
            html += specVal(p.specs[spec.key]);
          });
        });
      });

      html += '</div>';
      return html;
    }

    /* ── Render panels ── */

    function renderPicker() {
      var pA = products.find(function (p) { return p.id === selA.value; });
      var pB = products.find(function (p) { return p.id === selB.value; });
      pickerGrid.innerHTML = buildGrid([pA, pB], 'ota-compare__grid--two');
    }

    function renderAll() {
      allGrid.innerHTML = buildGrid(products, 'ota-compare__grid--four');
    }

    /* ── Tab switching ── */

    function showTab(view) {
      if (view === 'picker') {
        if (panelPicker) { panelPicker.hidden = false; }
        if (panelAll)    { panelAll.hidden = true; }
        if (tabPicker)   { tabPicker.classList.add('is-active'); }
        if (tabAll)      { tabAll.classList.remove('is-active'); }
        if (pickerGrid)  { renderPicker(); }
      } else {
        if (panelPicker) { panelPicker.hidden = true; }
        if (panelAll)    { panelAll.hidden = false; }
        if (tabAll)      { tabAll.classList.add('is-active'); }
        if (tabPicker)   { tabPicker.classList.remove('is-active'); }
        if (allGrid)     { renderAll(); }
      }
    }

    /* ── Events ── */

    if (tabPicker) { tabPicker.addEventListener('click', function () { showTab('picker'); }); }
    if (tabAll)    { tabAll.addEventListener('click', function () { showTab('all'); }); }
    if (selA)      { selA.addEventListener('change', renderPicker); }
    if (selB)      { selB.addEventListener('change', renderPicker); }

    /* ── Init ── */

    if (displayMode === 'compare-two-picker') {
      if (pickerGrid) { renderPicker(); }
    } else if (displayMode === 'compare-all-models') {
      if (allGrid) { renderAll(); }
    } else if (displayMode === 'compare-all-models-default') {
      showTab('all');
    } else {
      showTab('picker');
    }
  }
})();